import type { FC } from "react";
import { Outlet } from "react-router-dom";
import { Loader } from "../common/Loader";
import { MetaAdsClientSwitcher } from "./MetaAdsClientSwitcher";
import {
	MetaAdsSwitchProvider,
	useSwitchMetaAdsClient,
} from "./MetaAdsSwitchContext";
import "./MetaAdsLayout.css";

const MetaAdsSwitchOverlay: FC = () => {
	const { isSwitching, switchingLabel } = useSwitchMetaAdsClient();
	if (!isSwitching) return null;

	return (
		<div
			style={{
				position: "fixed",
				inset: 0,
				background: "rgba(255, 255, 255, 0.65)",
				zIndex: 1000,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
			aria-busy="true"
			aria-live="polite"
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					gap: 12,
					padding: "1.5rem 2rem",
					borderRadius: 12,
					background: "var(--bs-body-bg, #fff)",
					border: "1px solid var(--bs-border-color, #dee2e6)",
					boxShadow: "0 8px 28px rgba(15, 23, 42, 0.08)",
				}}
			>
				<Loader size="lg" />
				<div style={{ fontWeight: 600 }}>
					Switching to {switchingLabel ?? "client"}…
				</div>
				<div className="text-muted" style={{ fontSize: 13 }}>
					Loading campaigns and settings (target under 3 seconds)
				</div>
			</div>
		</div>
	);
};

export const MetaAdsLayout: FC = () => {
	return (
		<MetaAdsSwitchProvider>
			<div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
				<div className="meta-ads-layout-bar">
					<MetaAdsClientSwitcher />
				</div>
				<MetaAdsSwitchOverlay />
				<Outlet />
			</div>
		</MetaAdsSwitchProvider>
	);
};
